import React, { useRef } from "react";
import ReactSelect from "react-select";
import { customStyles } from "./Select";


const MultiSelect = (props) => {
  const valueRef = useRef(props.value);
  valueRef.current = props.value;
  const { selectAll } = props;

  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: selectAll === "All properties" ? "All properties" : "All rentals",
  };

  const isSelectAllSelected = () =>
    valueRef.current.length === props.options.length;

  const isOptionSelected = (option) => {
    const check =
      valueRef.current.some(({ value }) => value === option.value) ||
      isSelectAllSelected();
    return check;
  };

  const getOptions = () => {
    if(props.addAllOpt){
      return [...props.options]
    }else{
      return [selectAllOption, ...props.options]
    }
  }

  const getValue = () =>
    isSelectAllSelected() ? [selectAllOption] : props.value;

  const onChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      props.onChange(props.options, actionMeta);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      props.onChange([], actionMeta);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      props.onChange(
        props.options.filter(({ value }) => value !== option.value),
        actionMeta
      );
    } else {
      props.onChange(newValue || [], actionMeta);
    }
  };

  return (
    <ReactSelect
      isOptionSelected={isOptionSelected}
      options={getOptions()}
      value={getValue()}
      onChange={onChange}
      hideSelectedOptions={false}
      isMulti
      onBlur={props?.onBlur}
      isDisabled={props?.isDisabled}
      styles={customStyles(props?.onError)}
      placeholder={props?.placeholder}
    />
  );
};

export default MultiSelect;